/*global TTPermissionEnum */
/*eslint no-undef: "error"*/
import React, { Component } from 'react';
import { Link }             from 'react-router-dom';
import cx                   from 'classnames';

import { Page }               from 'moovila-common';

import Masthead     from './Masthead';
import reportConfig from '../constants/reportConfig';

import './Home.css';

const reports = reportConfig.map((report, i) => (
  <li key={i} className="Home__nav__item"><Link to={`/reports/configure/${report.code}`}>{report.name} <i className='fa fa-chevron-right' /></Link></li>
));

const navItems = [
  {
    title: 'Admin',
    permissionCodes: [TTPermissionEnum.UP_USER_ADMIN, TTPermissionEnum.UP_ROLE_ADMIN, TTPermissionEnum.UP_ENTERPRISE_PROFILE],
    iconClass: 'icon icon-moovila-admin',
    id: 'enterprise',
    items: [
      { name: 'Enterprise Maintenance', href:'/admin/enterprise-maintenance/enterprises', permissionCode: TTPermissionEnum.UP_USER_ADMIN },
      { name: 'License Maintenance', href:'/admin/license-maintenance', permissionCode: TTPermissionEnum.UP_USER_ADMIN },
    ],
  },
  {
    title: 'Utilities',
    permissionCodes: [TTPermissionEnum.UP_CHANNEL_ADMIN, TTPermissionEnum.UP_SUBSCRIPTION_CHANNEL_SELECTION, TTPermissionEnum.UP_PUBLICATION_APPROVAL],
    iconClass: 'icon icon-moovila-brand',
    id: 'utilities',
    items: [
      { name: 'API Console', href:'/utilities/api-console', permissionCode: TTPermissionEnum.UP_CHANNEL_ADMIN },
      { name: 'Repeat Tester', href:'/utilities/repeat-tester', permissionCode: TTPermissionEnum.UP_CHANNEL_ADMIN },
      { name: 'File Uploader', href:'/utilities/file', permissionCode: TTPermissionEnum.UP_CHANNEL_ADMIN },
      { name: 'General Info', href:'/utilities/info', permissionCode: TTPermissionEnum.UP_SUBSCRIPTION_CHANNEL_SELECTION },
    ],
  },
];

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openNavs: [],
    };
    this.handleViewMoreClick = this.handleViewMoreClick.bind(this);
  }

  handleViewMoreClick(id) {
    const index = this.state.openNavs.indexOf(id);
    if (index < 0) {
      this.setState({
        openNavs: [
          ...this.state.openNavs,
          id,
        ],
      });
      return;
    }
    this.setState({
      openNavs: [
        ...this.state.openNavs.slice(0, index),
        ...this.state.openNavs.slice(index + 1),
      ],
    });
  }

// .Home__nav__container--open {
//   max-height: 99999px;
// }
  render() {
    const reportStyles    = this.state.openNavs.indexOf('reports') >= 0 ? { maxHeight: 360 } : {};
    const reportIconClass = cx({
      'fa': true,
      'fa-chevron-up': this.state.openNavs.indexOf('reports') >= 0,
      'fa-chevron-down': this.state.openNavs.indexOf('reports') < 0,
    });
    const reportViewMoreStyle = cx({
      'Home__nav__view-more': true,
      'Home__nav__view-more--open': this.state.openNavs.indexOf('reports') >= 0,
    });

    return (
      <div>
        <Masthead />
        <Page>
          <ul className='Home__nav'>
            {
              navItems.map((nav, i) => {
                {/* <CheckPermissionSet key={i} permissionCodes={nav.permissionCodes}> */}
                return (
                  <li key={i} className='Home__nav__container'>
                    <h2 className='Home__nav__title'>
                      <i className={`Home__nav__icon ${nav.iconClass}`} />
                      {nav.title}
                    </h2>
                    <ul className='Home__nav__list'>
                      {
                        nav.items.map((item, j) => {
                          {/* <CheckPermission key={j} permissionCode={item.permissionCode}> */}
                          return (
                            <li className="Home__nav__item" key={j}>
                              { item.href.match(/^https?:\/\//) ?
                                <a href={item.href} target="_blank">{item.name} <i className='fa fa-chevron-right' /></a>
                                :
                                <Link to={item.href}>{item.name} <i className='fa fa-chevron-right' /></Link>
                              }
                            </li>
                          );
                          {/* </CheckPermission> */}
                        })
                      }
                    </ul>
                  </li>
                );
                {/* </CheckPermissionSet> */}
              })
            }
            {/* <CheckPermissionSet permissionCodes={[TTPermissionEnum.UP_REPORTS]}> */}
              <li className='Home__nav__container Home__nav__container--has-more'>
                <h2 className='Home__nav__title'>
                  <i className='Home__nav__icon fa fa-bar-chart' />
                  Reports
                </h2>
                <ul className='Home__nav__list Home__nav__list--has-more' style={reportStyles}>
                  { reports }
                </ul>
                <div className={reportViewMoreStyle} onClick={() => this.handleViewMoreClick('reports')}>
                  { this.state.openNavs.indexOf('reports') < 0 ? 'View more' : 'View less' }
                  <i className={reportIconClass} />
                </div>
              </li>
            {/* </CheckPermissionSet> */}
          </ul>
        </Page>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js